import { MoCommand } from './command';

/**
 * ActorObject command for handling stopping (play idle animation)
 *
 * @event enter When this command enters.
 * @event leave When this command leaves.
 * @event finish When we reach our target position.
 *
 * @param object
 * @constructor
 */
export class StopCmd extends MoCommand {
  constructor(object: any) {
    super(object);
  }

  enter() {
    this.object.pawn.playIdleMotion();
  }

  leave() {
  }

  update(delta: number) {
    if (this.wantInterrupt) {
      this.isComplete = true;
      return delta;
    }
    return 0;
  }
}

